import { combineReducers } from '@reduxjs/toolkit'

import list from './listSlice'
import dashboard from './dashboardSlice'
import roles from './rolesSlice'
import users from './usersSlice'
import customers from './customersSlice'
import inspectors from './inspectorsSlice'
import projects from './projectsSlice'
import transformers from './transformersSlice'
import testTypes from './testTypesSlice'
import transformerTests from './transformerTestsSlice'
import tests from './testsSlice'
import transReports from './transReportsSlice'
import feedbacks from './feedbacksSlice'
import reports from './reports'

const reducer = combineReducers({
    list,
    dashboard,
    roles,
    users,
    customers,
    inspectors,
    projects,
    transformers,
    testTypes,
    transformerTests,
    tests,
    transReports,
    feedbacks,
    reports,
})

export default reducer
